<template>
    <div id="process-paintlists-page">
        <ui5-button @click="$router.push('/paintlistform')">
            {{ trans('pages.processpaintlists.back_to_overview') }}
        </ui5-button>

        <div id="columns-grid">
            <div class="main-column">
                <h2>
                    {{ trans('pages.processpaintlists.paintshop') }}
                </h2>

                <div class="form-group">
                    <ui5-label for="paintshop">
                        {{ trans('pages.edit_product.paintshop') }}
                    </ui5-label>
                    <ui5-select
                        id="paintshop"
                        @change="paintshop = $event.detail.selectedOption.value"
                    >
                        <ui5-option :value="null">
                            {{ trans('pages.edit_product.select_paintshop') }}
                        </ui5-option>
                        <ui5-option
                            v-for="option in paintshopOptions"
                            :key="'paintshopOption.' + option.value"
                            :selected="paintshop == option.value"
                            :value="option.value"
                        >
                            {{ option.label }}
                        </ui5-option>
                    </ui5-select>
                </div>
            </div>

            <div class="main-column">
                <h2>{{ trans('pages.processpaintlists.bt_orders') }}</h2>

                <div v-if="paintshop">
                    <ui5-label
                        for="work-days"
                        wrapping-type="Normal"
                    >
                        {{ trans('pages.processpaintlists.work_days_label') }}
                    </ui5-label>
                    <text-input
                        type="number"
                        @blur="saveSettings"
                        v-model="workDays"
                        :disabled="processingBB"
                        id="work-days"
                    />

                    <ui5-button
                        id="process-BT-orders"
                        @click="calculatePaintlists"
                        :disabled="savingSettings || processingBB"
                        @mouseover="$refs.tooltipBT.showAt($event.target)"
                        @mouseout="$refs.tooltipBT.close()"
                    >
                        {{ trans('pages.processpaintlists.process_bt_orders') }}
                    </ui5-button>
                    <ui5-popover
                        class="tooltip"
                        ref="tooltipBT"
                        :allow-target-overlap="false"
                        placement-type="Bottom"
                    >
                        <div>
                            {{
                                trans(
                                    'pages.processpaintlists.process_bt_tooltip'
                                )
                            }}
                        </div>
                    </ui5-popover>

                    <div v-if="processingBBerror">
                        {{
                            trans(
                                'pages.processpaintlists.no_paintlists_created'
                            )
                        }}
                    </div>

                    <spinner-text v-if="processingBB">
                        {{ trans('pages.processpaintlists.processing_orders') }}
                    </spinner-text>
                    <template v-if="paintlistList">
                        <div>
                            {{
                                trans(
                                    'pages.processpaintlists.paintlists_created',
                                    { count: paintlistList.length }
                                )
                            }}
                        </div>
                        <ul id="paintlistList">
                            <li
                                v-for="paintlistId in paintlistList"
                                :key="'bb.' + paintlistId"
                            >
                                <a
                                    @click="
                                        $router.push(
                                            '/optimizedpaintlistview/' +
                                                paintlistId
                                        )
                                    "
                                >
                                    {{ paintlistId }}
                                </a>
                            </li>
                        </ul>
                    </template>
                </div>
            </div>

            <div class="main-column">
                <h2>{{ trans('pages.processpaintlists.close_basket') }}</h2>

                <div v-if="paintshop">
                    <div id="maxProductionDate">
                        <ui5-label
                            for="day"
                            wrapping-type="Normal"
                        >
                            {{
                                trans('pages.processpaintlists.choose_deadline')
                            }}
                            <small>(yyyy-mm-dd)</small>
                            :
                        </ui5-label>
                        <ui5-date-picker
                            id="day"
                            name="day"
                            ref="datePicker"
                            format-pattern="yyyy-MM-dd"
                            @click="$refs.datePicker.openPicker()"
                            @change="
                                maxProductionDate = $event.detail.value;
                                saveSettings();
                            "
                            :value="maxProductionDate"
                        />
                    </div>

                    <ui5-label
                        for="max-colors"
                        wrapping-type="Normal"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.max_colors_per_order'
                            )
                        }}
                    </ui5-label>
                    <text-input
                        type="number"
                        id="max-colors"
                        v-model="maxColors"
                    />

                    <spinner-text
                        style="clear: both"
                        v-if="autoProcessing"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.creating_paintwork_order'
                            )
                        }}
                    </spinner-text>

                    <div
                        style="clear: both"
                        v-if="productionDateProcessed"
                    >
                        <div
                            v-for="paintworkformId in productionDateProcessed"
                            :key="'lw.' + paintworkformId"
                            @click="
                                $router.push(
                                    '/paintworkformdetails/' + paintworkformId
                                )
                            "
                            class="link"
                        >
                            {{
                                trans(
                                    'pages.processpaintlists.paintwork_order_created',
                                    { id: paintworkformId }
                                )
                            }}
                        </div>
                    </div>

                    <br />

                    <ui5-button
                        style="clear: both"
                        @click="manualClick"
                        @mouseover="$refs.tooltipManual.showAt($event.target)"
                        @mouseout="$refs.tooltipManual.close()"
                    >
                        {{ trans('pages.processpaintlists.manual') }}
                    </ui5-button>
                    <ui5-popover
                        class="tooltip"
                        ref="tooltipManual"
                        :allow-target-overlap="false"
                        placement-type="Bottom"
                    >
                        <div>
                            {{
                                trans('pages.processpaintlists.manual_tooltip')
                            }}
                        </div>
                    </ui5-popover>

                    <span
                        style="clear: both"
                        v-if="manuallyCreatedId"
                        id="paintlistform-manual-processed"
                        @click="
                            $router.push(
                                '/paintworkformdetails/' + manuallyCreatedId
                            )
                        "
                        class="link"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.paintwork_order_created',
                                { id: manuallyCreatedId }
                            )
                        }}
                    </span>

                    <hr />

                    <ui5-button
                        style="clear: both"
                        @click="processPaintlistsForProductionDate"
                        :disabled="savingSettings"
                        @mouseover="$refs.tooltipProfile.showAt($event.target)"
                        @mouseout="$refs.tooltipProfile.close()"
                    >
                        {{ trans('pages.processpaintlists.profile') }}
                    </ui5-button>
                    <ui5-popover
                        class="tooltip"
                        ref="tooltipProfile"
                        :allow-target-overlap="false"
                        placement-type="Bottom"
                    >
                        <div>
                            {{
                                trans('pages.processpaintlists.profile_tooltip')
                            }}
                        </div>
                    </ui5-popover>

                    <spinner-text
                        style="clear: both"
                        v-if="deliveryDateCounter.loading"
                    >
                        {{
                            trans('pages.processpaintlists.counting_paintlists')
                        }}
                    </spinner-text>
                    <template v-else>
                        <div
                            class="paintlistred"
                            v-if="deliveryDateCounter.error"
                        >
                            {{
                                trans('pages.processpaintlists.counting_failed')
                            }}
                        </div>
                        <div
                            v-else
                            style="clear: both"
                        >
                            {{
                                trans(
                                    'pages.processpaintlists.paintlist_count',
                                    {
                                        count: deliveryDateCounter.count,
                                    }
                                )
                            }}
                        </div>
                    </template>

                    <ui5-button
                        id="errors-process-paintlists"
                        @click="errorsClick"
                        :disabled="
                            creatingFromErrors ||
                            errorCounter.error ||
                            errorCounter.count == 0
                        "
                    >
                        {{ trans('pages.processpaintlists.error_messages') }}
                    </ui5-button>
                    <spinner-text
                        style="clear: both"
                        v-if="errorCounter.loading"
                    >
                        {{
                            trans('pages.processpaintlists.counting_paintlists')
                        }}
                    </spinner-text>
                    <div
                        class="paintlistred"
                        v-if="errorCounter.error"
                    >
                        {{ trans('pages.processpaintlists.counting_failed') }}
                    </div>
                    <div v-else>
                        {{
                            trans('pages.processpaintlists.paintlist_count', {
                                count: errorCounter.count,
                            })
                        }}
                    </div>
                    <span
                        style="clear: both"
                        v-if="errorsProcessedCreated"
                        @click="
                            $router.push(
                                '/paintworkformdetails/' +
                                    errorsProcessedCreated
                            )
                        "
                        class="link"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.paintwork_order_created',
                                { id: errorsProcessedCreated }
                            )
                        }}
                    </span>

                    <ui5-button
                        id="urgent-process-paintlists"
                        @click="urgentClick"
                        :disabled="
                            creatingFromUrgent ||
                            urgentCounter.error ||
                            urgentCounter.count == 0
                        "
                    >
                        {{ trans('pages.processpaintlists.urgent') }}
                    </ui5-button>
                    <spinner-text
                        style="clear: both"
                        v-if="urgentCounter.loading"
                    >
                        {{
                            trans('pages.processpaintlists.counting_paintlists')
                        }}
                    </spinner-text>
                    <div
                        class="paintlistred"
                        v-if="urgentCounter.error"
                    >
                        {{ trans('pages.processpaintlists.counting_failed') }}
                    </div>
                    <div v-else>
                        {{
                            trans('pages.processpaintlists.paintlist_count', {
                                count: urgentCounter.count,
                            })
                        }}
                    </div>
                    <span
                        style="clear: both"
                        v-if="urgentCreated"
                        @click="
                            $router.push(
                                '/paintworkformdetails/' + urgentCreated
                            )
                        "
                        class="link"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.paintwork_order_created',
                                { id: urgentCreated }
                            )
                        }}
                    </span>

                    <ui5-button
                        id="urgent-process-paintlists"
                        @click="pleatingClick"
                        :disabled="
                            creatingFromPleating ||
                            pleatingCounter.error ||
                            pleatingCounter.count == 0
                        "
                    >
                        {{ trans('pages.processpaintlists.pleating') }}
                    </ui5-button>
                    <spinner-text
                        style="clear: both"
                        v-if="pleatingCounter.loading"
                    >
                        {{
                            trans('pages.processpaintlists.counting_paintlists')
                        }}
                    </spinner-text>
                    <div
                        class="paintlistred"
                        v-if="pleatingCounter.error"
                    >
                        {{ trans('pages.processpaintlists.counting_failed') }}
                    </div>
                    <div v-else>
                        {{
                            trans('pages.processpaintlists.paintlist_count', {
                                count: pleatingCounter.count,
                            })
                        }}
                    </div>
                    <span
                        style="clear: both"
                        v-if="pleatingCreated"
                        @click="
                            $router.push(
                                '/paintworkformdetails/' + pleatingCreated
                            )
                        "
                        class="link"
                    >
                        {{
                            trans(
                                'pages.processpaintlists.paintwork_order_created',
                                { id: pleatingCreated }
                            )
                        }}
                    </span>
                </div>
            </div>

            <div class="main-column">
                <h2>{{ trans('pages.processpaintlists.brut_sawing') }}</h2>
                <spinner-text v-if="loadingPaintworkForms && paintshop">
                    {{
                        trans(
                            'pages.processpaintlists.fetching_paintwork_orders'
                        )
                    }}
                </spinner-text>
                <div
                    v-else
                    id="paintworkforms-to-saw"
                    style="margin: 5%"
                >
                    <ui5-button
                        v-for="paintworkForm in paintworkForms"
                        :key="'paintworkForm.' + paintworkForm.paintworkorderId"
                        @click="
                            $router.push(
                                '/optimizedpaintlistview/' +
                                    paintworkForm.lastPaintlist
                            )
                        "
                    >
                        {{ paintworkForm.paintworkorderId }} -
                        {{ paintworkForm.dateCreated }} -
                        {{
                            paintworkForm.sawn
                                ? trans('pages.processpaintlists.sawn')
                                : trans('pages.processpaintlists.in_progress')
                        }}
                    </ui5-button>
                </div>
            </div>
        </div>

        <ui5-dialog
            id="popup-manual"
            ref="popupManual"
        >
            <div>
                <h2>
                    {{
                        trans(
                            'pages.processpaintlists.manual_create_paintwork_order'
                        )
                    }}
                </h2>
                <ui5-button @click="$refs.popupManual.close()">
                    {{ trans('pages.processpaintlists.cancel') }}
                </ui5-button>
                <ui5-button
                    :disabled="
                        !toProcess ||
                        toProcess.filter((x) => x.selected).length == 0
                    "
                    @click="saveCreatePaintworkform"
                >
                    {{ trans('pages.processpaintlists.create_order') }}
                </ui5-button>

                <spinner-text v-if="!toProcess">
                    {{ trans('pages.processpaintlists.fetching_paintlists') }}
                </spinner-text>
                <div
                    v-else
                    class="paintlists"
                >
                    <div
                        class="paintlist"
                        v-for="paintlist in toProcess"
                        :key="'pl.' + paintlist.ID"
                    >
                        <ui5-checkbox
                            :selected="paintlist.selected"
                            @change="paintlist.selected = $event.target.checked"
                        />
                        {{ paintlist.ID }} - {{ paintlist.deadline }} -
                        {{ paintlist.color.ralnr }}{{ paintlist.color.raltype }}
                        {{ paintlist.color.poedernr }}
                        {{ paintlist.color.producent }}
                        ({{ paintlist.color.description }}) -
                        {{
                            paintlist.paintshop
                                ? paintlist.paintshop.name || ''
                                : ''
                        }}
                        - {{ paintlist.productId }} - {{ paintlist.name }},
                        {{ paintlist.reference }}
                    </div>
                </div>
            </div>
        </ui5-dialog>
    </div>
</template>
<script>
import paintWorkOrderApi from '../api/paintWorkOrder';
import paintshopApi from '../api/paintshop';
import SpinnerText from '../components/loader/SpinnerText';
import optimizedPaintListApi from '../api/optimizedPaintList';
import settingsApi from '../api/settings';
import partslistApi from '../api/partslist';
import IsDebugMixin from '../mixins/is-debug';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput';
import { optimizedPaintListType } from '../shared/optimizedPaintListType';

export default {
    mixins: [IsDebugMixin, localization],
    components: { SpinnerText, TextInput },
    data() {
        return {
            maxColors: 9,
            maxProductionDate: '',
            workDays: '',
            autoProcessing: false,
            processingBB: false,
            processingBBerror: false,
            loadingPaintworkForms: false,
            paintworkForms: null,
            manuallyCreatedId: null,
            toProcess: null,
            errorCounter: {
                error: false,
                loading: false,
                count: 0,
            },
            urgentCounter: {
                error: false,
                loading: false,
                count: 0,
            },
            pleatingCounter: {
                error: false,
                loading: false,
                count: 0,
            },
            deliveryDateCounter: {
                error: false,
                loading: false,
                count: 0,
            },
            productionDateProcessed: null,
            paintlistList: null,
            errorsProcessedCreated: null,
            urgentCreated: null,
            pleatingCreated: null,
            savingSettings: false,
            creatingFromUrgent: false,
            creatingFromErrors: false,
            creatingFromPleating: false,
            paintshop: null,
            paintshopOptions: [],
        };
    },
    watch: {
        paintshop(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.loadPaintshopData();
            }
        },
    },
    mounted() {
        this.fetchPaintshopOptions();

        settingsApi
            .fetchSettings([
                'processPaintlistOverviewWorkdays',
                'processPaintlistOverviewNumber',
                'processPaintlistOverviewDate',
            ])
            .then((response) => {
                const settings = response.data.data;
                this.workDays = settings.processPaintlistOverviewWorkdays;
                this.maxProductionDate = settings.processPaintlistOverviewDate;
                this.loadPaintshopData();
            })
            .catch(() => {
                showErrorMessage(
                    this.trans(
                        'pages.processpaintlists.error_fetching_settings'
                    )
                );
            });
    },
    methods: {
        handlePaintworkCreationError(error) {
            const errorMessage = error.response?.data?.data ||
                this.trans('pages.processpaintlists.paintwork_order_creation_error');
            showErrorMessage(errorMessage, null, null);
        },
        fetchPaintshopOptions() {
            paintshopApi.fetchOptions().then((response) => {
                this.paintshopOptions = response.data.data || [];

                const defaultOption = this.paintshopOptions.find(
                    (x) => x.default
                );

                if (defaultOption && !this.paintshop) {
                    this.paintshop = defaultOption.value;
                }
            });
        },
        urgentClick() {
            this.creatingFromUrgent = true;
            this.urgentCreated = null;
            paintWorkOrderApi
                .createFromExpress(true, this.paintshop)
                .then((response) => {
                    showInfoMessage(
                        this.trans(
                            'pages.processpaintlists.paintwork_order_created_success'
                        )
                    );
                    this.urgentCreated = response.data.data.paintworkformID;
                    this.loadPaintshopData();
                })
                .catch(this.handlePaintworkCreationError)
                .finally(() => {
                    this.creatingFromUrgent = false;
                });
        },
        pleatingClick() {
            this.creatingFromPleating = true;
            this.pleatingCreated = null;
            paintWorkOrderApi
                .createFromPleating(true, this.paintshop)
                .then((response) => {
                    showInfoMessage(
                        this.trans(
                            'pages.processpaintlists.paintwork_order_created_success'
                        )
                    );
                    this.pleatingCreated = response.data.data.paintworkformID;
                    this.loadPaintshopData();
                })
                .catch(this.handlePaintworkCreationError)
                .finally(() => {
                    this.creatingFromPleating = false;
                });
        },
        errorsClick() {
            this.creatingFromErrors = true;
            this.errorsProcessedCreated = null;
            paintWorkOrderApi
                .createFromErrors(true, this.paintshop)
                .then((response) => {
                    showInfoMessage(
                        this.trans(
                            'pages.processpaintlists.paintwork_order_created_success'
                        )
                    );
                    this.errorsProcessedCreated =
                        response.data.data.paintworkformID;
                    this.loadPaintshopData();
                })
                .catch(this.handlePaintworkCreationError)
                .finally(() => {
                    this.creatingFromErrors = false;
                });
        },
        loadPaintshopData() {
            this.countAll();
            this.loadLatestPaintworkForms();
        },
        countAll() {
            this.errorCounter.count = 0;
            this.errorCounter.error = false;
            this.errorCounter.loading = true;
            optimizedPaintListApi
                .fetchCountWithErrorWithoutPaintworkform(this.paintshop)
                .then((response) => {
                    this.errorCounter.count = parseInt(response.data.data);
                })
                .catch(() => {
                    this.errorCounter.error = true;
                })
                .finally(() => {
                    this.errorCounter.loading = false;
                });

            this.urgentCounter.count = 0;
            this.urgentCounter.error = false;
            this.urgentCounter.loading = true;
            optimizedPaintListApi
                .fetchCountWithExpressWithoutPaintworkform(this.paintshop)
                .then((response) => {
                    this.urgentCounter.count = parseInt(response.data.data);
                })
                .catch(() => {
                    this.urgentCounter.error = true;
                })
                .finally(() => {
                    this.urgentCounter.loading = false;
                });

            this.pleatingCounter.count = 0;
            this.pleatingCounter.error = false;
            this.pleatingCounter.loading = true;
            optimizedPaintListApi
                .fetchCountWithPleatingWithoutPaintworkform(this.paintshop)
                .then((response) => {
                    this.pleatingCounter.count = parseInt(response.data.data);
                })
                .catch(() => {
                    this.pleatingCounter.error = true;
                })
                .finally(() => {
                    this.pleatingCounter.loading = false;
                });

            this.deliveryDateCounter.count = 0;
            this.deliveryDateCounter.error = false;
            this.deliveryDateCounter.loading = true;
            partslistApi
                .countForProductionDate(
                    this.maxProductionDate,
                    [optimizedPaintListType.TYPE_PROFILE],
                    this.paintshop
                )
                .then((response) => {
                    this.deliveryDateCounter.count =
                        response.data.data.paintlists;
                })
                .catch(() => {
                    this.deliveryDateCounter.error = true;
                })
                .finally(() => {
                    this.deliveryDateCounter.loading = false;
                });
        },
        saveSettings() {
            const datePicker = this.$refs.datePicker;
            if (datePicker.valueState == 'Error') {
                return showErrorMessage(
                    this.trans('pages.processpaintlists.invalid_date_format')
                );
            }
            if (parseInt(this.workDays) != this.workDays) {
                return showErrorMessage(
                    this.trans('pages.processpaintlists.invalid_workdays')
                );
            }
            this.savingSettings = true;
            settingsApi
                .updateSettings({
                    processPaintlistOverviewWorkdays: parseInt(this.workDays),
                    processPaintlistOverviewDate: this.maxProductionDate,
                })
                .then(() => {
                    this.loadPaintshopData();
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.processpaintlists.error_saving_settings'
                        )
                    );
                })
                .finally(() => {
                    this.savingSettings = false;
                });
        },
        manualClick() {
            this.$refs.popupManual.show();
            this.toProcess = null;
            optimizedPaintListApi
                .fetchToProcess(this.paintshop, [
                    optimizedPaintListType.TYPE_PROFILE,
                    optimizedPaintListType.TYPE_PLEATING,
                ])
                .then((response) => {
                    const items = response.data.data;
                    items.forEach((item) => {
                        item.selected = false;
                    });
                    this.toProcess = items;
                });
        },
        saveCreatePaintworkform() {
            paintWorkOrderApi
                .create(
                    this.toProcess.filter((x) => x.selected).map((x) => x.ID),
                    true
                )
                .then((response) => {
                    showInfoMessage(
                        this.trans(
                            'pages.processpaintlists.paintwork_order_created_success'
                        )
                    );
                    this.manuallyCreatedId = response.data.data.paintworkformID;
                    this.$refs.popupManual.close();
                    this.loadLatestPaintworkForms();
                })
                .catch(this.handlePaintworkCreationError);
        },
        processPaintlistsForProductionDate() {
            this.autoProcessing = true;
            this.productionDateProcessed = null;

            partslistApi
                .processForProductionDate(
                    this.maxColors,
                    this.maxProductionDate,
                    false,
                    [optimizedPaintListType.TYPE_PROFILE],
                    this.paintshop
                )
                .then((response) => {
                    this.productionDateProcessed =
                        response.data.data.paintworkforms;
                    this.loadLatestPaintworkForms();
                })
                .catch((error) => {
                    const errorMessage = error.response?.data?.data ||
                        this.trans('pages.processpaintlists.no_paintwork_order_created');

                    // Pass null as timeout to prevent auto-dismissal
                    showErrorMessage(errorMessage, null, null);
                })
                .finally(() => {
                    this.autoProcessing = false;
                });
        },
        loadLatestPaintworkForms() {
            this.loadingPaintworkForms = true;
            paintWorkOrderApi
                .listLatest(true, this.paintshop)
                .then((response) => {
                    this.paintworkForms = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.processpaintlists.error_fetching_brut_sawing'
                        )
                    );
                })
                .finally(() => {
                    this.loadingPaintworkForms = false;
                });
        },
        calculatePaintlists() {
            this.processingBB = true;
            this.processingBBerror = false;
            this.paintlistList = null;
            partslistApi
                .calculateWithProductionDate(this.workDays, this.paintshop)
                .then((response) => {
                    this.paintlistList = response.data.data.paintlists;
                    this.loadPaintshopData();
                })
                .catch(() => {
                    this.processingBB = true;
                })
                .finally(() => {
                    this.processingBB = false;
                });
        },
    },
};
</script>
